import AxiosConfig from '../../../config/AxiosConfig';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../states/app/staticSlice';

function useTemplateCreate() {
  const dispatch = useDispatch();
  const createTemplate = async (formData) => {
    try {
      const response = await AxiosConfig.create('post', `/templates/create`)
        .call(formData)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error ${response?.status} - ${response?.message} in useTemplateCreate`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      }
      return response;
    } catch (err) {
      console.error('Failed to create template:', err);
      throw new Error(`Creating template failed: ${err.message}`);
    }
  };

  return {
    createTemplate,
  };
}

export default useTemplateCreate;
